// extracted by mini-css-extract-plugin
export default {"icon":"ProfilesListIcon_icon__U0fpI","disabled":"ProfilesListIcon_disabled__FeMPg"};